"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var report_tree_to_table_parser_1 = require("./report-tree-to-table-parser");
var columns_change_event_1 = require("../../model/event/columns-change-event");
var column_highlight_event_1 = require("../../model/event/column-highlight-event");
var tree_view_manager_1 = require("./tree-view-manager");
var Subject_1 = require("rxjs/Subject");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var branch_index_regulator_1 = require("../../service/branch-index-regulator");
var columns_change_event_type_1 = require("../../model/event/columns-change-event-type");
var HeadCellDragAndDropManager = /** @class */ (function () {
    function HeadCellDragAndDropManager(fetchColumnsViewModel, table, viewEventService) {
        var _this = this;
        this.subscriptions = [];
        this.fetchColumnsViewModel = fetchColumnsViewModel;
        this.table = table;
        this.viewEventService = viewEventService;
        this.tableChangeInput = new Subject_1.Subject();
        this.tableChangeOutput = new Subject_1.Subject();
        this.subscriptions.push(this.tableChangeInput.asObservable().subscribe(function (t) { return _this.table = t; }));
        this.branchIndexRegulator = new branch_index_regulator_1.BranchIndexRegulator();
    }
    HeadCellDragAndDropManager.prototype.draggable = function (cell) {
        return !cell.node.isNew && !cell.node.isDefaultNew;
    };
    HeadCellDragAndDropManager.prototype.dragstart = function (event, cell) {
        if (!cell.node.isNew && !cell.node.isDefaultNew) {
            // store drag node and set it's isDragging flag to true
            this.dragNode = cell.node;
            cell.node.isDragging = true;
            // calculate and store node's branch indexes before dragging
            this.branchIndexRegulator.calculateAndStoreBranchIndexes(this.getTree(), 'columnBranchIndexBefore');
        }
    };
    HeadCellDragAndDropManager.prototype.dragenter = function (event, cell) {
        if (!this.dragNode) {
            return;
        }
        if (!cell.node.isNew && !cell.node.isDefaultNew && !cell.node.isDragEntered) {
            // clean drag entered flags and set current node as drag entered
            this.getTree().cleanDragEnteredFlags();
            cell.node.isDragEntered = true;
            // not add temporary nodes when drag over same node.
            if (cell.node !== this.dragNode) {
                // do not add temporary nodes when drop is not allowed in both (right and bottom) positions.
                var rightBranchNodes = tree_view_manager_1.TreeViewManager.fetchBranchNodes(cell.node.parent);
                var rightBranchPathIds_1 = tree_view_manager_1.TreeViewManager.fetchBranchPathIds(cell.node.parent);
                var rightBranchHasMeasureElement = rightBranchNodes.filter(function (columnView) { return columnView.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto; }).length > 0;
                var bottomBranchNodes = tree_view_manager_1.TreeViewManager.fetchBranchNodes(cell.node);
                var bottomBranchPathIds_1 = tree_view_manager_1.TreeViewManager.fetchBranchPathIds(cell.node);
                var bottomBranchHasMeasureElement = bottomBranchNodes.filter(function (columnView) { return columnView.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto; }).length > 0;
                var dragNodes = event.ctrlKey ? tree_view_manager_1.TreeViewManager.fetchSubTreeNodes(this.dragNode) : Array.of(this.dragNode);
                var dragPathIds = event.ctrlKey ? tree_view_manager_1.TreeViewManager.fetchSubTreePathIds(this.dragNode) :
                    Array.of(tree_view_manager_1.TreeViewManager.fetchPathId(this.dragNode));
                var dragHasMeasureElement = dragNodes.filter(function (columnView) { return columnView.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto; }).length > 0;
                var elementAlreadyExistsInRightBranch = dragPathIds.some(function (dragPathId) { return rightBranchPathIds_1.includes(dragPathId); });
                var elementAlreadyExistsInBottomBranch = dragPathIds.some(function (dragPathId) { return bottomBranchPathIds_1.includes(dragPathId); });
                // do not allow to drop event in position where specified conditions not matched.
                // branch must not already contains same path, and branch must have only one measure path.
                var branchHasMeasureElement = rightBranchHasMeasureElement && bottomBranchHasMeasureElement;
                var elementAlreadyExists = elementAlreadyExistsInRightBranch && elementAlreadyExistsInBottomBranch;
                var skipBoth = (branchHasMeasureElement && dragHasMeasureElement) || (elementAlreadyExists);
                if (!skipBoth) {
                    var skipSibling = (rightBranchHasMeasureElement && dragHasMeasureElement) || elementAlreadyExistsInRightBranch;
                    var skipChild = (bottomBranchHasMeasureElement && dragHasMeasureElement) || elementAlreadyExistsInBottomBranch;
                    // add temporary new nodes
                    tree_view_manager_1.TreeViewManager.addTempNodes(cell.node, !skipChild, !skipSibling);
                }
                else {
                    this.getTree().clean();
                }
            }
            else {
                this.getTree().clean();
            }
            // parse column tree view to table element
            this.redraw(this.table.options);
            this.tableChangeOutput.next(this.table);
            // send event on table columns depth changed
            this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this.table.columnsDepth, this.getCurrentBranchIndexesDifference(this.getTree()), columns_change_event_type_1.ColumnsChangeEventType.TEMP_COLUMNS_ADDED));
        }
        else {
            this.getTree().cleanHighlightedFlags();
            cell.node.isHighlighted = true;
            this.viewEventService.columnHighlighted(new column_highlight_event_1.ColumnHighlightEvent(true));
        }
    };
    HeadCellDragAndDropManager.prototype.dragover = function (event, cell) {
        if (!this.dragNode) {
            return false;
        }
        // toggle dragging sub tree
        for (var i = 0; i < this.dragNode.children.length; i++) {
            this.setSubTreeDragging(this.dragNode.children[i], event.ctrlKey);
        }
        if (cell.node === this.dragNode) {
            event.preventDefault();
            return true;
        }
        if (cell.node.isNew || cell.node.isDefaultNew) {
            var branchNodes = tree_view_manager_1.TreeViewManager.fetchBranchNodes(cell.node);
            var branchPathIds_1 = tree_view_manager_1.TreeViewManager.fetchBranchPathIds(cell.node);
            var branchHasMeasureElement = branchNodes.filter(function (columnView) { return columnView.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto; }).length > 0;
            var dragNodes = event.ctrlKey ? tree_view_manager_1.TreeViewManager.fetchSubTreeNodes(this.dragNode) : Array.of(this.dragNode);
            var dragPathIds = event.ctrlKey ? tree_view_manager_1.TreeViewManager.fetchSubTreePathIds(this.dragNode) :
                Array.of(tree_view_manager_1.TreeViewManager.fetchPathId(this.dragNode));
            var dragHasMeasureElement = dragNodes.filter(function (columnView) { return columnView.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto; }).length > 0;
            var elementAlreadyExists = dragPathIds.some(function (dragPathId) { return branchPathIds_1.includes(dragPathId); });
            // do not allow to drop event in position where specified conditions not matched.
            // branch must not already contains same path, and branch must have only one measure path.
            if ((branchHasMeasureElement && dragHasMeasureElement) || (elementAlreadyExists)) {
                return false;
            }
            event.preventDefault();
            return true;
        }
        return false;
    };
    HeadCellDragAndDropManager.prototype.drop = function (event, cell) {
        var dropNode = cell.node;
        if (dropNode.isNew || dropNode.isDefaultNew) {
            var index = this.dragNode.index;
            var parent_1 = this.dragNode.parent;
            var removeSubTree = event.ctrlKey;
            var draggingNode = removeSubTree ? parent_1.popTreeWithIndex(index) : parent_1.popNodeWithIndex(index);
            this.getTree().recalculateIndexes();
            // add node/subtree to parent node of new-node with index.
            dropNode.parent.addWithIndex(draggingNode, dropNode.index);
            // clean tree and regenerate table.
            this.getTree().clean();
            this.redraw(this.table.options);
            this.tableChangeOutput.next(this.table);
            // send event on table columns depth changed
            this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this.table.columnsDepth, this.getCurrentBranchIndexesDifference(this.getTree()), columns_change_event_type_1.ColumnsChangeEventType.COLUMN_MOVED));
        }
        else {
            // clean tree and regenerate table.
            this.getTree().clean();
            this.redraw(this.table.options);
            this.tableChangeOutput.next(this.table);
            this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this.table.columnsDepth, this.getCurrentBranchIndexesDifference(this.getTree())));
        }
        // clean tree temporary drag flags.
        this.getTree().cleanDragFlags();
        this.dragNode = undefined;
    };
    HeadCellDragAndDropManager.prototype.dragend = function (event, data) {
        // clean tree and regenerate table.
        this.getTree().clean();
        this.redraw(this.table.options);
        this.tableChangeOutput.next(this.table);
        this.viewEventService.columnsChanged(new columns_change_event_1.ColumnsChangeEvent(this.table.columnsDepth, this.getCurrentBranchIndexesDifference(this.getTree())));
        // clean tree temporary drag flags.
        this.getTree().cleanDragFlags();
        this.dragNode = undefined;
    };
    HeadCellDragAndDropManager.prototype.dragleave = function (event, data) {
    };
    HeadCellDragAndDropManager.prototype.destroy = function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    HeadCellDragAndDropManager.prototype.getTree = function () {
        // invoke fetchColumnsViewModel Lambda function to fetch columns tree model from component.
        return this.fetchColumnsViewModel();
    };
    HeadCellDragAndDropManager.prototype.redraw = function (options) {
        var isLastRowContainsOnlyTempNode = this.isLastRowContainsOnlyTempNode();
        this.table = report_tree_to_table_parser_1.ReportTreeToTableParser.parse(this.getTree(), options);
        this.table.lastRowTempNodeRemoved = isLastRowContainsOnlyTempNode && !this.isLastRowContainsOnlyTempNode();
    };
    HeadCellDragAndDropManager.prototype.setSubTreeDragging = function (node, enable) {
        node.isDragging = enable;
        for (var i = 0; i < node.children.length; i++) {
            this.setSubTreeDragging(node.children[i], enable);
        }
    };
    HeadCellDragAndDropManager.prototype.getCurrentBranchIndexesDifference = function (tree) {
        var branchIndexesDif = new Map();
        this.branchIndexRegulator.calculateAndStoreBranchIndexes(tree, 'columnBranchIndexAfter');
        this.branchIndexRegulator.constructDifferenceMap(branchIndexesDif, tree, 'columnBranchIndexBefore', 'columnBranchIndexAfter');
        return branchIndexesDif;
    };
    HeadCellDragAndDropManager.prototype.isLastRowContainsOnlyTempNode = function () {
        if (!this.table) {
            return false;
        }
        var lastRow = this.table.head[this.table.head.length - 1];
        return lastRow.length === 1 && lastRow[0].node.isNew;
    };
    return HeadCellDragAndDropManager;
}());
exports.HeadCellDragAndDropManager = HeadCellDragAndDropManager;
//# sourceMappingURL=headcell-drag-and-drop-manager.js.map